import { createCtx } from '@mi-front/core';

export interface TimezoneCtx {
  timezone: string | null;
}

export const [useTimezoneCtx, TimezoneCtxProvider] = createCtx<TimezoneCtx>({
  throwIfMissingProvider: false,
});
